import { useContext, useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { AuthContext } from "../../context/AuthContext";
import { useTheme } from "../../context/ThemeContext";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import NumberCard from "../../components/Card/NumberCard";
import Loader from "../../components/Loader";
import { useTranslation } from "react-i18next";

export default function EventTop() {
  ChartJS.register(ArcElement, Tooltip, Legend);
  const { apiUrl } = useContext(AuthContext);
  const { theme } = useTheme();
  const { t } = useTranslation();

  const [dataForChart, setDataForChart] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [options, setOptions] = useState({});
  const [days, setDays] = useState(7);
  const [limit, setLimit] = useState(10);

  const getTopEvent = async () => {
    try {
      const res = await axios.get(`${apiUrl}umbrella/events_graph/${days}/${limit}`, {
        withCredentials: true,
      });
      let count = 0;
      res.data.data.forEach((event) => {
        count += event.count;
      });
      setTotalCount(count);
      return res.data.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return []; // Retournez un tableau vide en cas d'erreur
    }
  };

  const eventType = useQuery({
    queryKey: ["eventType"],
    queryFn: getTopEvent,
  });

  useEffect(() => {
    eventType.refetch();
  }, [days, limit]);

  const filterEventForChart = () => {
    if (!eventType.data) {
      return;
    }

    const labels = eventType.data.map((event) => event.eventtype);
    const data = eventType.data.map((event) => event.count);

    const colors = [
      "#997adb",
      "#124188",
      "rgb(250, 131, 52)",
      "rgba(75, 192, 192, 1)",
      "#aec353",
      "#ff0000",
      "rgb(255, 232, 24)",
    ];

    const backgroundColor = labels.map((_, index) => colors[index % colors.length]);

    const datasets = [
      {
        label: "Count",
        data: data,
        backgroundColor: backgroundColor,
        borderColor: theme === "dark" ? "#303030" : "#ffffff",
        borderWidth: 1,
      },
    ];

    setDataForChart({ labels, datasets });

    setOptions({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        title: {
          display: true,
          position: "top",
          text: t("Type des événements"),
          align: "center",
          padding: 20,
          color: theme === "dark" ? "#ffffff" : "#303030",
          font: {
            family: "Inter",
            size: "15",
          },
        },
        legend: {
          labels: {
            padding: 15,
            color: theme === "dark" ? "#ffffff" : "#303030",
            font: {
              family: "Inter",
              size: 11,
              weight: 700,
            },
            usePointStyle: true,
          },
        },
      },
    });
  };

  useEffect(() => {
    if (eventType.data) {
      filterEventForChart();
    }
  }, [eventType.data, theme]);

  return (
    <>
      <section className="page-section mt-1">
        <NumberCard title="Nombre d'événements" number={totalCount} />
        <div className="page-section_form">
          <form className="form">
            <div className="form-input_container limit">
              <select
                className="only"
                id="days"
                onChange={(e) => setDays(e.target.value)}
              >
                <option value="7">7</option>
                <option value="15">15</option>
                <option value="30">30</option>
              </select>
              <label htmlFor="days">{t('derniers jours')}</label>
            </div>
          </form>
          <form className="form">
            <div className="form-input_container limit">
              <select
                className="only"
                id="limit"
                onChange={(e) => setLimit(e.target.value)}
              >
                <option value="10">10</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
              </select>
              <label htmlFor="limit">{t('derniers événements')}</label>
            </div>
          </form>
        </div>
      </section>
      <div>
        {!eventType.isFetching && dataForChart.labels ? (
          <section className="page-chart">
            <Doughnut
              key={theme}
              data={dataForChart}
              options={options}
              width={100}
              height={600}
            />
          </section>

        ) : (
          <Loader />
        )}
      </div>
    </>
  );
}